import { Component, OnInit , Output,EventEmitter,Input} from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService, CandidatesService } from '../../../../services';

@Component({
    selector: 'app-delete-confirmation-modal',
    templateUrl: './delete-confirmation-modal.html',
    styleUrls: ['./delete-confirmation-modal.scss']
})

export class DeleteConfirmationModalComponent implements OnInit {
    @Output() notifyParent = new EventEmitter<any>();
    @Input() Title  = "";
    
    constructor(private authService: AuthService,private candidatesService: CandidatesService, private location: PlatformLocation,public activeModal: NgbActiveModal) {
    	location.onPopState(() => { this.activeModal.close();});
    }

    ngOnInit() {}

    closeModal(state){
    	this.activeModal.close({status:state});
    }
}
